export default __webpack_public_path__ + "static/media/Crypto_tracker.a47cf9d6.webp";